(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var memberTable = function memberTable(options) {
    var $ = jQuery;

    // Default options
    var settings = $.extend({
        errors: 0,
        edit_button: '.user-table-editable'
    }, options);

    var init = function init() {
        $(settings.edit_button).click(function () {
            var user_id = $(this).attr('user-id');
            toggleEditableRow(user_id);
        });
    };

    var toggleEditableRow = function toggleEditableRow(user_id) {
        console.log(user_id);
    };

    return init();
};

(function ($) {
    $.fn.memberTable = memberTable;
})(jQuery);

var AgentMember = function AgentMember(errors) {
    //console.log('Create Agent Member Object');
    this.errors = errors;
    this.eventBinding();
};

AgentMember.prototype = function () {
    var create_form = jQuery('#create_member').closest('form');
    var member_table = jQuery('#member-table-editable');

    var ajax = jQuery.ajax;
    var $ = function $(str) {
        return create_form.find(str);
    };

    return {
        constructor: AgentMember,
        eventBinding: function eventBinding() {
            $('#account0').change(this.onAccountChanged);
            $('#account1').change(this.onAccountChanged);
            $('#account2').change(this.onAccountChanged);
            $('#btnCheck').click(this.checkAvailability);
            $('#refreshCaptcha').click(this.reloadCaptcha);
            jQuery('#Button22').click(function () {
                create_form.submit();
            });

            if (this.errors) {
                var message = '';
                jQuery.each(this.errors, function (i, item) {
                    message += item + "\n";
                });
                alert(message);
            }
        },
        checkAvailability: function checkAvailability() {
            var account0 = $('#account0').val();
            var account1 = $('#account1').val();
            var account2 = $('#account2').val();

            var account = $('#account').val();

            //var captcha = $('#vcode').val();

            ajax({
                url: "check",
                method: "POST",
                data: { account: account, account0: account0, account1: account1, account2: account2 }
            }).done(function (data) {
                if (data.status) {
                    alert('The username selected is available!');
                } else {
                    alert('The username selected already exists!\nPlease select a different username.');
                }
            });
        },
        reloadCaptcha: function reloadCaptcha() {
            var d = new Date();
            $('#imgText').attr("src", '/captcha/default?' + d.getTime());
        },
        onAccountChanged: function onAccountChanged() {}
    };
}();

window.AgentMember = AgentMember;

$(document).ready(function () {
    // tab function
    $('.tab > .tab-header > span').click(function () {
        var tab = $(this).closest('.tab');
        if (tab.hasClass('close')) {
            $(this).addClass('minus');
            $(this).removeClass('plus');
            tab.removeClass('close');
        } else {
            $(this).removeClass('minus');
            $(this).addClass('plus');
            tab.addClass('close');
        }
    });

    $('.menu-item').click(function () {
        var url = $(this).attr('menu-link');
        window.open(url, '_self');
    });

    $('#btn_signout').click(function () {
        var url = $(this).attr('target-url');
        window.open(url, '_self');
    });
});

},{}]},{},[1]);
